// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const farmPaths = {
    list:   ()    => 'admin/farms',
    detail: (id)  => `admin/farms/${id}`,
};
